import { render, staticRenderFns } from "./ViewFundsTransfer.vue?vue&type=template&id=74e46924&"
import script from "./ViewFundsTransfer.vue?vue&type=script&lang=js&"
export * from "./ViewFundsTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports